import { Card, Typography, Box } from "@mui/material";
import { CleaningObject } from "../../context/scope-of-work.types";
import { colors, alphaVar } from "../../../../../../ui/colors";
import { cleanDescription } from "../../helpers/normalizedAreasFromBackend";

const COLORS = {
  orange: {
    base: colors.orange.base,
  },
  gray: {
    100: "#F3F4F6",
    200: "#E5E7EB",
    400: "#9CA3AF",
    500: "#6B7280",
    600: "#4B5563",
  },
};

interface ObjectsCardProps {
  object: CleaningObject;
  selected: boolean;
  onSelect: () => void;
}

export const ObjectsCard = ({ object, selected, onSelect }: ObjectsCardProps) => {
  const highlight = selected ? COLORS.orange.base : COLORS.gray[100];
  const borderColor = selected ? alphaVar(COLORS.orange.base, 0.6) : alphaVar(COLORS.gray[200], 0.8);

  return (
    <Card
      onClick={onSelect}
      sx={{
        backgroundColor: "var(--fx-surface-base, #FFFFFF)",
        borderRadius: 2,
        border: `2px solid ${borderColor}`,
        boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
        transition: "all 0.2s ease",
        overflow: "hidden",
        cursor: "pointer",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: `0 6px 12px ${alphaVar(COLORS.orange.base, 0.25)}`,
          borderColor: alphaVar(COLORS.orange.base, 0.5),
        },
        height: 180,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        position: "relative",
      }}
    >
      <Box
        sx={{
          width: 100,
          height: 80,
          borderRadius: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 600,
          color: COLORS.gray[600],
          mb: 1,
          fontSize: 13,
        }}
      >
        <Box
          component="img"
          src={object.imageUrl}
          alt={object.name}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Box>

      <Typography
        variant="subtitle2"
        fontWeight={700}
        sx={{
          color: selected ? COLORS.orange.base : COLORS.gray[600],
          fontSize: 13,
          textAlign: "center",
          mb: 0.5,
        }}
      >
        {object.name}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: COLORS.gray[500],
          fontSize: 12,
          textAlign: "center",
          mb: 1,
        }}
      >
        {cleanDescription(object?.description)}
      </Typography>

      {/* Hide cost
      <Typography
        variant="body2"
        fontWeight={600}
        sx={{
          color: selected ? COLORS.orange.base : COLORS.gray[400],
          fontSize: 13,
        }}
      >
        Cost: ${object.cost?.value ?? 0}
      </Typography>

*/}
    </Card>
  );
};
